export default __webpack_public_path__ + "static/flow-6dba4becdffd169811ced73194a4d7d4.png";